import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFormSyncErrors, getFormValues} from 'redux-form';
import ArticleForm from './ArticleForm';
import ArticleViewPage from './view/ArticleViewPage';
import * as articleActions from '../../actions/articleActions';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import * as contactPersonModalActions from '../../actions/contactPersonModalActions';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as modalActions from '../../actions/common/modalActions';
import * as vimeoActions from '../../actions/vimeoActions';
import * as articleCategoryActions from '../../actions/articleCategoryActions';
import ContactPersonModal from '../contact-person/ContactPersonModal';
import PreviewModal from '../common/PreviewModal';
import ArticleParamsFormatter from "../../services/ArticleParamsFormatter";
import FormDataFormatter from '../../services/FormDataFormatter';
import {toastr} from 'react-redux-toastr';
import moment from 'moment';
import {DATE_TIME_FORMAT} from '../../components/helpers/DateHelper';
import Template from "../Template";
import TemplateModal from "./TemplateModal";
const DEFAULT_TEMPLATE = 4;
import {FormattedMessage, injectIntl} from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from '../ResetFormModal';

import ArticleCategoriesSerializer from "../../services/ArticleCategoriesSerializer";

class ArticleFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.submit = this.submit.bind(this);
        this.onModalClick = this.onModalClick.bind(this);
        this.isUpdate = this.isUpdate.bind(this);
        this.handleReset = this.handleReset.bind(this);

        this.state = {
            uploadedImages: []
        };
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [
            this.props.actions.loadContactPersons(this.props.user.company.id),
            this.props.actions.loadCategories({portalId: this.props.user.company.portalId, active: true}, true),
        ];

        if (this.isUpdate()) {
            actions.push(this.props.actions.getArticle(this.props.match.params.id));
        } else {
            actions.push(this.props.actions.resetArticle());
        }

        return actions;
    }

    componentWillReceiveProps(nextProp) {

        if(
            nextProp.formValues.vimeoId !== '' &&
            this.props.formValues.vimeoId !== nextProp.formValues.vimeoId &&
            this.props.match.params.id
        ) {
            let vimeoId = nextProp.formValues.vimeoId;
            this.props.actions.updateArticleVimeo(this.props.match.params.id, {vimeoId});
        }

        // if form not ready yet or we don't need to load modal yet
        if(!Object.keys(this.props.formValues).length) {
            this.props.actions.hidePreviewModal();
        }

        if(nextProp.showPreviewModal && Object.keys(this.props.errors).length) {
            this.props.actions.showSweetAlertModal(this.props.intl.formatMessage(messages.mustFillRequiredFields));
            this.props.actions.hidePreviewModal();
        }

        if(!nextProp.formValues
            || !Object.keys(nextProp.formValues).length
            || JSON.stringify(this.props.formValues.images) === JSON.stringify(nextProp.formValues.images)
        ) {
            return;
        }

        let imagePromises = nextProp.formValues.images.map(image => {
            return new Promise(function(resolve, reject){
                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = function(e) {
                    resolve(reader.result);
                };
            });
        });

        if(imagePromises.length) {
            Promise.all(imagePromises)
                .then(image => image)
                .then(images => this.setState({uploadedImages: images}));
        }
        else {
            this.state.uploadedImages = [];
        }
    }

    submit(formFields) {
        if(formFields.vimeoId) {
            this.props.actions.updateVimeoVideo(formFields.vimeoId, {name: formFields.vimeoName || formFields.heading, description: formFields.vimeoDescription})
                .then(() => {
                    this.sendForm(formFields);
                });
        } else {
            this.sendForm(formFields);
        }
    }

    sendForm(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let formDataFields = {...formFields};
        formDataFields.categories = formFields.categoryIds.map(category => category.value);
        formDataFields.publishAt = this.getUnixStamp(formFields.publishAt);
        let formattedFields = Object.assign({}, formDataFields);
        let formData = FormDataFormatter.getFormData(formattedFields);
        if(this.isUpdate()) {
            this.props.actions.updateArticle(formData, this.props.match.params.id).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.articleUpdated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        } else {
            this.props.actions.saveArticle(formData).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.articleCreated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        }
    }

    getPreviewModalContent() {
        let {
            formValues,
            errors,
            contactPersons,
            templates,
        } = this.props;

        // if form not ready yet or we don't need to load modal yet
        if(!Object.keys(formValues).length || Object.keys(errors).length || !formValues.categoryIds) {
            return null;
        }

        let templateId = formValues.templateId;

        let categories = formValues.categoryIds.map((item, key) => {
            return {name: item.label};
        });

        let images = formValues.defaultImages.slice();
        this.state.uploadedImages.forEach(src => images.push({path: src}));


        return <ArticleViewPage
            article={{
                heading: formValues.heading,
                resume: formValues.resume,
                description: formValues.description,
                youtubeId: formValues.youtubeId,
                categories: categories,
                contactPerson: contactPersons.find(contactPersonItem => parseInt(contactPersonItem.id) === parseInt(formValues.contactPersonId)),
                template: templates.find(templateItem => parseInt(templateItem.id) === parseInt(templateId)),
                publishAt: this.getUnixStamp(formValues.publishAt),
                images: images,
            }}
        />
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    /**
     *
     * @param {string} dateString
     * @returns {integer}
     */
    getUnixStamp(dateString) {
        return moment(dateString, DATE_TIME_FORMAT).unix();
    }

    onModalClick() {
        this.props.actions.showContactPersonModal();
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    redirect() {
        this.context.router.history.push('/nyhed');
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">
                                    {this.isUpdate() ?
                                        this.props.intl.formatMessage(messages.articleUpdate)
                                        : this.props.intl.formatMessage(messages.articleCreate)
                                        }
                                </h1>
                                <ArticleForm
                                    initialValues={this.props.article}
                                    article={this.props.article}
                                    contactPersons={this.props.contactPersons}
                                    handleModalClick={this.onModalClick}
                                    handleReset={this.handleReset}
                                    templates={this.props.templates}
                                    categories={this.props.categories}
                                    onSubmit={this.submit}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    showArticlePreviewModal={this.props.actions.showPreviewModal}
                                    isUpdate={this.isUpdate()}
                                    isAdmin={this.props.user.isAdmin}
                                    isLoggedInAs={this.props.isLoggedInAs}
                                    sentOutAt={this.props.article.sentOutAt}
                                />
                                <ContactPersonModal/>
                            </div>
                        </div>
                    </div>
                </div>
                <TemplateModal isUpdate={this.isUpdate()}/>
                <PreviewModal>
                    {this.getPreviewModalContent()}
                </PreviewModal>
                <ResetFormModal
                    modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                    modalContent={
                        <p>
                            <FormattedMessage
                                id="reset.modal.message"
                                defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                            />
                        </p>}
                    confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                    closeText={this.props.intl.formatMessage(messages.buttonNo)}
                    handleConfirm={() => {this.confirmReset()}}
                />
            </div>
            </WithResolvedPromises>
        );
    }
}

ArticleFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    let errors = Object.assign({}, getFormSyncErrors('article')(state));
    let formValues = Object.assign({}, getFormValues('article')(state));
    let article = ArticleParamsFormatter.convertToForm(state.article);
    let categories = ArticleCategoriesSerializer.unserialize(state.articleCategories);

    let isLoggedInAs = state.demoAdminUser && state.demoAdminUser.isAdmin;

    return {
        article,
        contactPersons: state.contactPersons,
        templates: state.articleTemplates,
        categories,
        showPreviewModal: state.showPreviewModal,
        user: state.user,
        errors,
        formValues,
        isLoggedInAs,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                articleActions,
                articleCategoryActions,
                contactPersonListActions,
                contactPersonModalActions,
                modalActions,
                submitButtonActions,
                vimeoActions
            ), dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ArticleFormContainer));


// WEBPACK FOOTER //
// ./web/src/components/articles/ArticleFormContainer.jsx